import React from 'react';

/**
 * From dropdown (Josh 10/13: "for compose from a deal page, allow me to select the sender from a drop down").
 * `sender` is the backend's {audience, default_id, options:[{id, name, from_email, configured, is_legal, builtin}]}
 * (GET /gmail/sender-options, or the `sender` block on the outreach / bounce-notice / document previews).
 * The server already filtered the list: a broker-facing email never offers a legal@ mailbox.
 */
const SenderSelect = ({ sender, value, onChange, dark = false, className = '' }) => {
  if (!sender || !Array.isArray(sender.options) || sender.options.length === 0) return null;
  const selected = value || sender.default_id || 'env';
  const chosen = sender.options.find((o) => o.id === selected);
  const base = dark
    ? 'w-full h-9 rounded-md border border-slate-600 bg-slate-800 text-slate-100 px-3 text-sm'
    : 'w-full h-9 rounded-md border border-gray-200 px-3 text-sm';
  return (
    <div className={className}>
      <label className={`text-xs uppercase tracking-wide ${dark ? 'text-slate-400' : 'text-gray-600'}`}>From</label>
      <select className={base} value={selected} onChange={(e) => onChange(e.target.value)} data-testid="sender-select">
        {sender.options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.name}{o.from_email ? ` <${o.from_email}>` : ''}{o.id === sender.default_id ? ' · default' : ''}{o.configured ? '' : ' · password not set'}
          </option>
        ))}
      </select>
      {chosen && !chosen.configured && (
        <div className={`text-[11px] mt-1 ${dark ? 'text-amber-300' : 'text-amber-700'}`}>
          This mailbox has no app password on Railway — the Default sender will be used instead.
        </div>
      )}
      {sender.audience === 'broker' && (
        <div className={`text-[11px] mt-1 ${dark ? 'text-slate-500' : 'text-gray-500'}`}>Admin mailboxes only (legal departments are offered for merchant emails).</div>
      )}
    </div>
  );
};

export default SenderSelect;
